/**
 * Trust bar: <trust-count> — count from start-num to end-display.
 * Supports Latin, Arabic-Indic (٠–٩), and Persian (۰–۹) digits + Arabic separators.
 */
(function () {
  // Wall-clock duration for every counter (time-based rAF, not setInterval).
  var COUNT_DURATION_MS = 3000;

  var DIGITS_ARABIC_INDIC = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
  var DIGITS_PERSIAN = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];

  var SEP_WRAP_RE = /[,\u060C\u066C]/g;

  function escapeHtml(t) {
    return String(t)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /** Wrap thousands separators for mobile-only .sp-trust-sep styling (plain text in, HTML out). */
  function wrapSeparatorsForDisplay(s) {
    var str = String(s);
    var html = '';
    var last = 0;
    var m;
    SEP_WRAP_RE.lastIndex = 0;
    while ((m = SEP_WRAP_RE.exec(str)) !== null) {
      html += escapeHtml(str.slice(last, m.index));
      html += '<span class="sp-trust-sep">' + escapeHtml(m[0]) + '</span>';
      last = m.index + m[0].length;
    }
    html += escapeHtml(str.slice(last));
    return html;
  }

  /** Map Arabic-Indic / Persian digits and separators to ASCII for parsing. */
  function normalizeForParse(s) {
    var t = String(s);
    t = t.replace(/\u066C/g, ','); // ٬ thousands
    t = t.replace(/\u060C/g, ','); // ، Arabic comma
    t = t.replace(/\u066B/g, '.'); // ٫ decimal
    t = t.replace(/[\u0660-\u0669]/g, function (c) {
      return String(c.charCodeAt(0) - 0x0660);
    });
    t = t.replace(/[\u06F0-\u06F9]/g, function (c) {
      return String(c.charCodeAt(0) - 0x06F0);
    });
    return t;
  }

  function parseAttrNumber(s) {
    if (s == null || s === '') return NaN;
    var t = normalizeForParse(String(s)).replace(/,/g, '');
    var n = parseFloat(t);
    return n;
  }

  /** Fallback when \p{Nd} is unsupported or match fails (Arabic/Latin + separators only). */
  function parseLeadingNumberScan(s) {
    var i = 0;
    while (i < s.length) {
      var ch = s[i];
      var code = ch.charCodeAt(0);
      var isDigit =
        (code >= 0x0660 && code <= 0x0669) ||
        (code >= 0x06F0 && code <= 0x06F9) ||
        (ch >= '0' && ch <= '9');
      var isSep =
        ch === ',' ||
        ch === '.' ||
        ch === '\u066C' ||
        ch === '\u060C' ||
        ch === '\u066B';
      if (!isDigit && !isSep) break;
      i++;
    }
    if (i === 0) return { num: NaN, suffix: s, rawNum: '' };
    var rawNum = s.substring(0, i);
    var num = parseFloat(normalizeForParse(rawNum).replace(/,/g, ''));
    return { num: num, suffix: s.substring(i) || '', rawNum: rawNum };
  }

  /**
   * Leading number in any decimal digit set (Unicode Nd + common Arabic separators).
   */
  function parseLeadingNumber(str) {
    var s = String(str || '').trim();
    var m;
    try {
      m = s.match(/^((?:[\p{Nd}\u066C\u060C\u066B.,])+)(.*)$/u);
    } catch (e) {
      m = null;
    }
    if (m) {
      var rawNum = m[1];
      var num = parseFloat(normalizeForParse(rawNum).replace(/,/g, ''));
      return { num: num, suffix: m[2] || '', rawNum: rawNum };
    }
    return parseLeadingNumberScan(s);
  }

  function decimalPlacesFromRaw(raw) {
    var n = normalizeForParse(raw);
    var parts = n.split('.');
    return parts[1] ? parts[1].length : 0;
  }

  function digitStyleFromDisplay(display) {
    if (/[\u06F0-\u06F9]/.test(display)) return 'persian';
    if (/[\u0660-\u0669]/.test(display)) return 'arabic';
    return 'latin';
  }

  function mapLatinDigitsToStyle(str, style) {
    if (style === 'latin') return str;
    var map = style === 'persian' ? DIGITS_PERSIAN : DIGITS_ARABIC_INDIC;
    return str.replace(/\d/g, function (d) {
      return map[parseInt(d, 10)];
    });
  }

  function thousandsSepFromRaw(raw) {
    if (raw.indexOf('\u066C') !== -1) return '\u066C';
    if (raw.indexOf('\u060C') !== -1) return '\u060C';
    return ',';
  }

  function decimalSepFromRaw(raw) {
    if (raw.indexOf('\u066B') !== -1) return '\u066B';
    return '.';
  }

  /**
   * @param {boolean} [isFinal] — omit + during count; % and other suffix unchanged.
   */
  function formatAnimated(current, endDisplay, isFinal) {
    var end = parseLeadingNumber(endDisplay);
    if (!Number.isFinite(end.num)) return endDisplay;
    var raw = end.rawNum;
    var hasGrouping = /[,،\u060C\u066C]/.test(raw);
    var decPart = normalizeForParse(raw).split('.')[1];
    var decimals = decPart ? decPart.length : 0;
    var thSep = thousandsSepFromRaw(raw);
    var decSep = decimalSepFromRaw(raw);
    var style = digitStyleFromDisplay(endDisplay);

    var v;
    if (decimals > 0) {
      v = Number(current.toFixed(decimals));
    } else {
      v = Math.round(current);
    }

    var body;
    if (decimals > 0) {
      body = v.toFixed(decimals);
      if (hasGrouping) {
        var p = body.split('.');
        p[0] = parseInt(p[0], 10).toLocaleString('en-US');
        body = p.join('.');
      }
    } else if (hasGrouping) {
      body = Math.round(current).toLocaleString('en-US');
    } else {
      body = String(Math.round(current));
    }

    if (thSep !== ',') {
      body = body.replace(/,/g, thSep);
    }
    if (decimals > 0 && decSep !== '.') {
      body = body.replace(/\./g, decSep);
    }

    body = mapLatinDigitsToStyle(body, style);

    var suffix = end.suffix;
    if (!isFinal) {
      suffix = suffix.replace(/\+/g, '');
    }
    return body + suffix;
  }

  class TrustCount extends HTMLElement {
    connectedCallback() {
      var self = this;
      this._stopAnimation();

      var startDisplay = this.getAttribute('start-display');
      if (startDisplay != null && startDisplay !== '' && !this.querySelector('.sp-trust-sep')) {
        this.innerHTML = wrapSeparatorsForDisplay(startDisplay);
      }

      this._animFrame = requestAnimationFrame(function () {
        self._animFrame = null;
        if (self.isConnected) self._runAnimation();
      });
    }

    disconnectedCallback() {
      this._stopAnimation();
    }

    _stopAnimation() {
      if (this._animFrame != null) {
        cancelAnimationFrame(this._animFrame);
        this._animFrame = null;
      }
    }

    _runAnimation() {
      var el = this;
      var endDisplay = el.getAttribute('end-display') || '';
      var endAttr = el.getAttribute('end-num');
      var startAttr = el.getAttribute('start-num');
      var endN = parseAttrNumber(endAttr);
      var startN = parseAttrNumber(startAttr);
      var durationMs = COUNT_DURATION_MS;

      if (!Number.isFinite(endN)) {
        var parsedEnd = parseLeadingNumber(endDisplay);
        if (Number.isFinite(parsedEnd.num)) {
          endN = parsedEnd.num;
        }
      }

      if (!Number.isFinite(endN)) {
        el.innerHTML = wrapSeparatorsForDisplay(endDisplay);
        return;
      }

      if (!Number.isFinite(startN)) {
        startN = endN * 0.9;
      }

      var endParsed = parseLeadingNumber(endDisplay);
      if (!Number.isFinite(endParsed.num)) {
        endParsed = { num: endN, suffix: '', rawNum: String(endN) };
      }

      var decimals = decimalPlacesFromRaw(endParsed.rawNum);
      var scale = Math.pow(10, decimals);
      var startScaled = Math.round(startN * scale);
      var endScaled = Math.round(endParsed.num * scale);
      var delta = Math.abs(endScaled - startScaled);

      if (delta === 0) {
        el.innerHTML = wrapSeparatorsForDisplay(endDisplay);
        return;
      }

      var dir = endScaled >= startScaled ? 1 : -1;
      var startTime = performance.now();

      function tick(now) {
        if (!el.isConnected) {
          el._stopAnimation();
          return;
        }

        var elapsed = now - startTime;
        if (elapsed >= durationMs) {
          el.innerHTML = wrapSeparatorsForDisplay(endDisplay);
          return;
        }

        var progressed = Math.round(delta * Math.min(1, elapsed / durationMs));
        if (progressed <= 0) {
          el._animFrame = requestAnimationFrame(tick);
          return;
        }

        if (progressed >= delta) {
          el.innerHTML = wrapSeparatorsForDisplay(endDisplay);
          return;
        }

        var shownScaled = startScaled + dir * progressed;
        el.innerHTML = wrapSeparatorsForDisplay(formatAnimated(shownScaled / scale, endDisplay, false));
        el._animFrame = requestAnimationFrame(tick);
      }

      el._animFrame = requestAnimationFrame(tick);
    }
  }

  if (!customElements.get('trust-count')) {
    customElements.define('trust-count', TrustCount);
  }
})();
